'use client';

import useSWR from 'swr';
import { accountsApi } from '@/lib/api';
import type { Account } from '@/types';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useAccounts() {
  const authedFetch = useAuthedFetcher();

  return useSWR<Account[]>(
    ['accounts'],
    () => authedFetch((token) => accountsApi.getAll(token)),
    VOLATILE_SWR_OPTIONS,
  );
}
